import { space } from "@smartsheet/design-tokens";
import { sizes } from "../../../constants/spacing";
import { ScrollAreaGutter } from "../types";

// a ScrollAreaGutter that resolves to a single CSS length value (as opposed to a shorthand value)
type SingleLengthGutter = Exclude<ScrollAreaGutter, "legacy">;

const isLodestarSizeKey = (key: SingleLengthGutter): key is keyof typeof sizes => {
    return key in sizes;
};

const isUrsaSpaceKey = (key: SingleLengthGutter): key is keyof typeof space => {
    return key in space;
};

// map a SingleLengthGutter to one CSS length string
// this assumes Lodestar and Ursa constant names remain mutually exclusive
export const resolveGutterLength = (gutter: SingleLengthGutter): string => {
    if (isLodestarSizeKey(gutter)) {
        return `${sizes[gutter]}px`;
    }
    if (isUrsaSpaceKey(gutter)) {
        return space[gutter];
    }
    return "0px";
};
